var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLockIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 72,
    viewBox: "0 0 60 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_di_135_317)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M48.4379 19.7581H45.0875V16.4651C45.0875 7.38629 37.5724 6.10352e-05 28.3352 6.10352e-05C19.098 6.10352e-05 11.583 7.38629 11.583 16.4651V19.7581H8.23252C6.45533 19.7581 4.75093 20.452 3.49426 21.6871C2.2376 22.9223 1.53162 24.5975 1.53162 26.3442V59.2743C1.53162 61.021 2.2376 62.6962 3.49426 63.9313C4.75093 65.1665 6.45533 65.8603 8.23252 65.8603H48.4379C50.2151 65.8603 51.9195 65.1665 53.1762 63.9313C54.4328 62.6962 55.1388 61.021 55.1388 59.2743V26.3442C55.1388 24.5975 54.4328 22.9223 53.1762 21.6871C51.9195 20.452 50.2151 19.7581 48.4379 19.7581ZM18.2839 16.4651C18.2839 11.0185 22.7936 6.58609 28.3352 6.58609C33.8769 6.58609 38.3866 11.0185 38.3866 16.4651V19.7581H18.2839V16.4651ZM31.6857 45.1901V52.6883H24.9848V45.1901C22.9913 44.0507 21.6343 41.9498 21.6343 39.5162C21.6343 37.7695 22.3403 36.0943 23.597 34.8592C24.8536 33.6241 26.558 32.9302 28.3352 32.9302C30.1124 32.9302 31.8168 33.6241 33.0735 34.8592C34.3301 36.0943 35.0361 37.7695 35.0361 39.5162C35.0361 41.9465 33.6792 44.0474 31.6857 45.1901Z",
    fill: "#CAC7BF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_di_135_317",
    x: -0.0000181198,
    y: 0,
    width: 59.7337,
    height: 71.9868,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1.53163,
    dy: 3.06327
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.53163
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.929412 0 0 0 0 0.921569 0 0 0 0 0.901961 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_135_317"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_135_317",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1.53163,
    dy: 1.53163
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.29301
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_135_317"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLockIcon);
export default __webpack_public_path__ + "static/media/lockIcon.2228306344d92438b1181156727be1fe.svg";
export { ForwardRef as ReactComponent };